import { render, staticRenderFns } from "./form-produto-vinculo.vue?vue&type=template&id=11602a64&scoped=true&"
import script from "./form-produto-vinculo.vue?vue&type=script&lang=js&"
export * from "./form-produto-vinculo.vue?vue&type=script&lang=js&"
import style0 from "./form-produto-vinculo.vue?vue&type=style&index=0&id=11602a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11602a64",
  null
  
)

export default component.exports